import { Separator } from '@chakra-ui/react';
import {
  CollaborationAccessLevelEnum,
  QuoteStatusEnum,
  RecordShareEngagement,
} from '@monetize/types/app';
import { QuoteShareActivity } from './QuoteShareActivity';
import { useQuoteShare } from './useQuoteShare';

interface QuoteCollaborationExternalProps {
  quoteId: string;
  quoteExpirationDate: string;
  quoteStatus: QuoteStatusEnum;
  accessLevel: CollaborationAccessLevelEnum | null;
  engagements?: RecordShareEngagement[];
}

export const QuoteCollaborationExternal = ({
  quoteId,
  quoteExpirationDate,
  accessLevel,
  quoteStatus,
  engagements,
}: QuoteCollaborationExternalProps) => {
  const quoteShareData = useQuoteShare({
    accessLevel,
    quoteId,
    quoteStatus,
    engagements,
    quoteExpirationDate,
  });

  if (
    !quoteShareData.externalShareState.externalShareVisible ||
    !engagements?.length
  ) {
    return null;
  }

  return (
    <>
      <Separator my={6} />

      <QuoteShareActivity engagements={engagements} />
    </>
  );
};
